<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">تجربه کاری موردنیاز</h4>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-6 d-flex flex-column align-items-center">
          <label class="form-label fw-bold">سال</label>
          <select class="form-select" v-model="jobQualification.required_experience.years_experience">
            <option :value="null" disabled>سال را انتخاب کنید</option>
            <option :value="value" v-for="(value, index) in years" :key="index">{{ value }}</option>
          </select>
        </div>
        <div class="col-6 d-flex flex-column align-items-center">
          <label class="form-label fw-bold">ارتباط با شغل</label>
          <select class="form-select" v-model="jobQualification.required_experience.related_experience">
            <option :value="null" disabled>ارتباط با شغل را انتخاب کنید</option>
            <option :value="value" v-for="(value, index) in relations" :key="index">{{ value }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      years: [
        'زیر 5 سال',
        '5 تا 10 سال',
        '10 تا 15 سال',
        'بالای 15 سال',
      ],
      relations: [
        'مرتبط',
        'غیرمرتبط',
      ]
    }
  },
  computed: {
    jobQualification: {
      get() {
        return this.$store.state.jobQualification.jobQualification;
      },
    },
  }
}
</script>
